class FieldValidator {
  constructor(fieldElement) {
    try {
      this.el = fieldElement;
      this.tooltip = this.el.querySelector(".sd-tooltip");
      this.tooltip1 = document.querySelectorAll(".sd-tooltip");
      this.phoneNumbertooShortErr = document.getElementById("phoneNumbertooShortErr");
      this.phoneNumberErr = document.getElementById("phoneNumberErr");        
      this.formItem = this.el.querySelector(".sd-fieldset__item");
      this.input = this.formItem.querySelector(".sd-fieldset__input");
      this.validate = this.validate.bind(this);
    } catch (error) {
      console.log(error);
    }
  }

  showError() {
      if (this.formItem && this.tooltip) {
          this.formItem.classList.add("sd-input--error");
          this.tooltip.classList.add("sd-tooltip--error");
      }
           
      if (this.phoneNumbertooShortErr) {
          if (this.input.type === "tel" && this.input.value < 1) {
              this.phoneNumberErr.classList.add("sd-tooltip--error");
              this.phoneNumbertooShortErr.classList.remove("sd-tooltip--error");
          } else if (this.input.type === "tel" && (this.input.value.toString().length <= 7 || this.input.value.toString().length >= 21)) {
              this.phoneNumbertooShortErr.classList.add("sd-tooltip--error");
              this.phoneNumberErr.classList.remove("sd-tooltip--error");
          }
      }
      
  }
  showErrorSecond() {
    if (this.formItem && this.tooltip1) {
      this.formItem.classList.add("sd-input--error");
      this.tooltip1[4].classList.remove("sd-tooltip--error");
      this.tooltip1[5].classList.add("sd-tooltip--error");
      }
    }
    showSDPErrorSecond() {
        if (this.formItem && this.tooltip1) {
            this.formItem.classList.add("sd-input--error");
            this.phoneNumbertooShortErr.classList.add("sd-tooltip--error");

            if (this.phoneNumberErr) {
                if (this.phoneNumberErr.classList.contains("sd-tooltip--error")) {
                    this.phoneNumberErr.classList.remove("sd-tooltip--error");
              }
            }
        }
    }
  hideError() {
    if (this.formItem && this.tooltip) {
      this.tooltip.classList.remove("sd-tooltip--error");
      if (this.formItem.classList.contains("sd-input--error")) {
          this.tooltip1[5].classList.remove("sd-tooltip--error");
      }
        this.formItem.classList.remove("sd-input--error");       
      }
      
  }
  validate() {
    if (!this.input.validity.valid) {
      this.showError();
      return false;
    } else if (this.input.type === "checkbox" && !this.input.checked) {
      this.showError();
      return false;
    } else if (this.input.type === "range" && this.input.value < 1) {
      this.showError();
      return false;
    } else if (this.input.type === "number" && this.input.value < 1) {
      this.showError();
      return false;
    } else if (this.input.type === "tel" && this.phoneNumbertooShortErr == null && (this.input.value.toString().length <= 7 || this.input.value.toString().length >= 21)) {
      this.showErrorSecond();
      return false;
    } else if (this.input.type === "tel" && this.phoneNumbertooShortErr != null && (this.input.value.toString().length <= 7 || this.input.value.toString().length >= 21)) {
      this.showSDPErrorSecond();
      return false;
    } else {
      this.hideError();
      return true;
    }
  }

}

export default FieldValidator;
